module.exports = __webpack_public_path__ + "static/media/santa-reliquia-restaurada-virgen-coromoto.fb4ac828.jpg";